import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import "ant-design-vue/dist/antd.css";
import "./scss/style.scss";
import VueAnime from "vue-animejs";
import VueToastr from "vue-toastr";
import "bootstrap/dist/css/bootstrap.css";
import VueCarousel from "vue-carousel";
//Match height
import VueMatchHeights from "vue-match-heights";
//Fancybox
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
//Aos
import AOS from "aos";
import "aos/dist/aos.css";
import Embed from "v-video-embed";
import swal from "sweetalert";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

import capitalize from "lodash/capitalize";
import snakeCase from "lodash/snakeCase";
import _ from "lodash";
import permissions from "@/helpers/permission-module";
import moment from "moment";
import { BASE_URL } from "@/utils/api-url";

import {
  Row,
  Col,
  Button,
  Input,
  InputNumber,
  Select,
  Upload,
  Form,
  Radio,
  Checkbox,
  Table,
  Icon,
  Tag,
  Divider,
  Dropdown,
  Menu,
  Steps,
  Modal,
  notification,
  message,
  Popconfirm,
  Tooltip,
  Anchor,
  Alert,
  Cascader,
  TimePicker,
  DatePicker,
  Collapse,
  List,
  Badge,
  Drawer,
  Tabs,
  Carousel,
  Switch,
  Pagination
} from "ant-design-vue";
import generateImageUrl from "./utils/generate-image-url";
import ChatSockets from "@/helpers/chat-sockets";

for (const [key, value] of Object.entries(permissions)) {
  window[key] = value;
  Vue.prototype[key] = value;
}

Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Upload);
Vue.use(Form);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Table);
Vue.use(Icon);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Steps);
Vue.use(Modal);
Vue.use(Tooltip);
Vue.use(Anchor);
Vue.use(Alert);
Vue.use(Popconfirm);
Vue.use(Cascader);
Vue.use(TimePicker);
Vue.use(DatePicker);
Vue.use(List);
Vue.use(Collapse);
Vue.use(Badge);
Vue.use(Drawer);
Vue.use(Tabs);
Vue.use(Carousel);
Vue.use(Switch);
Vue.use(Pagination);

const requireComponent = require.context(
  // relative path to the components
  "./components",
  // whether to look inside subfolders
  false,
  //regex to match the filename
  /_base-[\w-]+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Look for the component options on `.default`, which will
  // exist if the component was exported with `export default`,
  // otherwise fall back to module's root.
  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.use(CoolLightBox);
Vue.use(Embed);
Vue.use(VueCarousel);
Vue.use(VueToastr);
Vue.use(VueAnime);
Vue.use(Vuelidate);

Vue.filter("humanize", (value, returnEmpty = false) => {
  if (!value && !returnEmpty) return "N/A";
  if (!value && returnEmpty) return "";
  if (value === "n/a") return "N/A";
  if (["=", "<", ">"].includes(value)) return value;
  const newValue = capitalize(snakeCase(value)).replace(/_/g, " ");
  return newValue || value;
});

Vue.filter("convertToFromNowFormat", date => {
  return moment(date).fromNow();
});

Vue.filter("humanizeDate", date => {
  return moment(date).format("MMM DD YYYY");
});

Vue.filter("humanizeMessageDate", date => {
  if (new Date(date).toDateString() === new Date().toDateString())
    return "Today";
  return moment(date).format("MMM DD YYYY");
});

Vue.filter("dateToTime", date => moment(date).format("h:mm A"));

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype._ = _;
Vue.prototype.baseUrl = BASE_URL;
Vue.prototype.generateImageUrl = generateImageUrl;
Vue.prototype.chatSockets = new ChatSockets({ url: BASE_URL, events: [] });
window.swal = swal;
Vue.config.productionTip = false;

Vue.use(VueMatchHeights, {
  disabled: [575]
});

new Vue({
  router,
  store,
  created() {
    AOS.init({
      duration: 600, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false // whether elements should animate out while scrolling past them
    });
  },
  render: h => h(App)
}).$mount("#app");
